import { useQuery } from "@tanstack/react-query";
import api from "@/lib/axios";
import {
  DailySalesClient,
  DailySalesTransaction,
  DailySalesSearchParams,
  DailySalesTotal,
} from "@/interface/settlement/dailySalesByClient";

// 거래처 목록 조회 (좌측 패널 - Page 응답)
// 매출일자 기간 내 거래가 있는 거래처만 조회
export const useDailySalesClients = (
  params: DailySalesSearchParams & { page?: number; size?: number }
) => {
  return useQuery<{
    content: DailySalesClient[];
    totalElements: number;
    totalPages: number;
    last: boolean;
  }>({
    queryKey: ["dailySalesClients", params],
    queryFn: async () => {
      const { data } = await api.get("/sale-slip/daily-sales-by-client/clients", {
        params: {
          startDate: params.startDate,
          endDate: params.endDate,
          company: params.company || "",
          searchType: params.searchType || "",
          search: params.search || "",
          exactMatch: params.exactMatch || false,
          itemSearchType: params.itemSearchType || "",
          itemSearch: params.itemSearch || "",
          page: params.page || 0,
          size: params.size || 20,
        },
      });
      return data.data;
    },
    enabled: !!params.startDate && !!params.endDate,
  });
};

// 선택된 거래처의 거래 내역 조회 (우측 패널)
export const useDailySalesTransactions = (
  companyCode: string,
  params: DailySalesSearchParams & { page?: number; size?: number }
) => {
  return useQuery<{
    content: DailySalesTransaction[];
    totalElements: number;
    totalPages: number;
    last: boolean;
  }>({
    queryKey: ["dailySalesTransactions", companyCode, params],
    queryFn: async () => {
      const { data } = await api.get(
        `/sale-slip/daily-sales-by-client/transactions/${companyCode}`,
        {
          params: {
            startDate: params.startDate,
            endDate: params.endDate,
            company: params.company || "",
            itemSearchType: params.itemSearchType || "",
            itemSearch: params.itemSearch || "",
            itemExactMatch: params.itemExactMatch || false,
            page: params.page || 0,
            size: params.size || 20,
          },
        }
      );
      return data.data;
    },
    enabled: !!companyCode && !!params.startDate && !!params.endDate,
  });
};

// 선택된 거래처의 거래 합계 조회 (Footer용)
export const useDailySalesTransactionTotals = (
  companyCode: string,
  params: DailySalesSearchParams
) => {
  return useQuery<DailySalesTotal>({
    queryKey: ["dailySalesTransactionTotals", companyCode, params],
    queryFn: async () => {
      const { data } = await api.get(
        `/sale-slip/daily-sales-by-client/transactions/${companyCode}/totals`,
        {
          params: {
            startDate: params.startDate,
            endDate: params.endDate,
            company: params.company || "",
            itemSearchType: params.itemSearchType || "",
            itemSearch: params.itemSearch || "",
            itemExactMatch: params.itemExactMatch || false,
          },
        }
      );
      return data.data;
    },
    enabled: !!companyCode && !!params.startDate && !!params.endDate,
  });
};
